import restApi from "../../http.js";
import env from "../../env.js";

export default class CareersApi {
  getEvents() {
    return restApi({
      method: "GET",
      url: "https://api.airtable.com/v0/appnhQAAp5rKtJc4i/Events",
      headers: {
        Authorization: "Bearer " + env.airTableToken(),
      },
    });
  }

  rsvpToEvent(request) {
    return restApi({
      method: "POST",
      url: "https://api.airtable.com/v0/appmMxK7snZWQEMpl/RSVPs",
      data: {
        fields: {
          Name: request.name,
          Email: request.email,
          Event: request.event,
        },
      },
      headers: {
        Authorization: "Bearer " + env.airTableToken(),
      },
    });
  }
}
